/**
 * Auto generated file, do not edit.
 */

export const appVersion = '0.1.97';
